import { ReactNode } from 'react'

import { NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import { clsx } from 'clsx'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

type ContainerProps = NodeViewProps & {
  children?: ReactNode
  className?: string
}
/**
 * Wrapper for video, audio, image and embed extensions with loading spinner
 * @param param0 - props passed to the extension
 */
export const Container = ({
  node,
  selected,
  children,
  className,
}: ContainerProps) => {
  const { loading } = node.attrs

  return (
    <NodeViewWrapper
      as="figure"
      className={clsx(
        'border-2 relative',
        selected ? 'border-focused' : 'border-transparent',
        loading && 'opacity-40',
        className,
      )}
    >
      {loading && (
        <SvgIcon
          className="absolute inset-0 m-auto w-16 h-16 animate-spin"
          width="auto"
          height="auto"
          name="spinner"
        />
      )}
      {children}
      {!selected && (
        <div
          className="absolute top-0 bottom-0 start-0 end-0 h-full w-full"
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}
        />
      )}
    </NodeViewWrapper>
  )
}
